<template>
  <div class="thumbtack-search">
    <input type="text" class="thumbtack-search-query" v-model="query" v-validate="'required'" placeholder="Task or Service"/>
    <div class="thumbtack-search-zip">
      <span class="thumbtack-search-zip-divider"></span>
      <i class="icon-map-pin-home"></i>
      <input type="text" v-model="zipCode" name="zipcode" v-validate="'required|zipcode'" placeholder="Zip Code"/>
    </div>
    <button type="submit"><i class="icon-search scale-150"></i></button>
  </div>
</template>

<script src="./thumbtacksearch.js"></script>

<style lang="scss">
@use './thumbtacksearch.scss' as *;
</style>